import React from "react";
import {useTranslation} from "react-i18next";
import {
  CardSubtitle,
  CardTitle,
  DividerLabel,
  DividerRow,
  FinePrint,
  LinkButton,
  OnboardingCard,
  SocialButton,
  SwitchRow
} from "./onboardingStyles";
import styled from "styled-components";

const ButtonStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const ButtonIcon = styled.img`
  width: 18px;
  height: 18px;
`;

const HeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

interface Props {
  onApple: () => void;
  onGoogle: () => void;
  onEmail: () => void;
  onLogin: () => void;
}

function AuthOptionsStep({onApple, onGoogle, onEmail, onLogin}: Props) {
  const {t} = useTranslation();

  return (
    <OnboardingCard gap="32px">
      <HeaderGroup>
        <CardTitle>{t("onboarding.createAccountTitle")}</CardTitle>
        <CardSubtitle>{t("onboarding.saveTracks")}</CardSubtitle>
      </HeaderGroup>
      <ButtonStack>
        <SocialButton variant="apple" onClick={onApple}>
          <ButtonIcon src="/assets/images/onboarding/apple-icon.svg" alt="" />
          {t("onboarding.continueWithApple")}
        </SocialButton>
        <SocialButton variant="google" onClick={onGoogle}>
          <ButtonIcon src="/assets/images/onboarding/google-icon.png" alt="" />
          {t("onboarding.continueWithGoogle")}
        </SocialButton>
        <DividerRow>
          <DividerLabel>{t("onboarding.or")}</DividerLabel>
        </DividerRow>
        <SocialButton variant="email" onClick={onEmail}>
          <ButtonIcon src="/assets/images/onboarding/mail-icon-grey.svg" alt="" />
          {t("onboarding.continueWithEmail")}
        </SocialButton>
      </ButtonStack>
      <SwitchRow>
        {t("onboarding.alreadyHaveAccount")}{" "}
        <LinkButton type="button" onClick={onLogin}>
          {t("onboarding.logIn")}
        </LinkButton>
      </SwitchRow>
      <FinePrint>{t("onboarding.agreeTerms")}</FinePrint>
    </OnboardingCard>
  );
}

export default AuthOptionsStep;
